import axios from 'axios';

const api = axios.create({
    //baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:9810/',
    //baseURL: process.env.REACT_APP_API_URL || 'http://localhost:9810/',
    baseURL:'https://ms.imgnet.com.br/catalogoFranquias/',
    timeout: 10000, // 10 segundos de timeout
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Request interceptor para debug
api.interceptors.request.use(
    request => {
        console.log('📤 Enviando requisição:', {
            url: request.url,
            method: request.method,
            data: request.data
        });
        return request;
    },
    error => {
        console.error('❌ Erro no request:', error);
        return Promise.reject(error);
    }
);

// Response interceptor para debug
api.interceptors.response.use(
    response => {
        console.log('📥 Resposta recebida:', {
            url: response.config.url,
            status: response.status,
            data: response.data
        });
        return response;
    },
    error => {
        console.error('❌ Erro na resposta:', {
            url: error.config?.url,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        return Promise.reject(error);
    }
)

// Funções auxiliares para as APIs
export const buscar_numero_itens = async (params) => {
    const response = await api.post('buscar_numero_itens', params);
    return response;
};

export const buscar_interesses = async (params) => {
    const response = await api.post('buscar_interesses', params);
    return response;
};

export const login_usuario = async (params) => {
    try {
        const response = await api.post('login', {
            dict_dados: {
                login: params.email,
                senha_login: params.senha,
                acao: 'login'
            }
        });

        // Backend retorna { login: true/false, data: id ou mensagem de erro }
        if (response.data.login) {
            return { success: true, data: { user: params.email, id: response.data.data } };
        } else {
            return { success: false, message: response.data.data };
        }
    } catch (error) {
        console.error('Erro ao fazer login:', error);
        return { success: false, message: 'Erro ao conectar com o servidor' };
    }
};

export const add_session_db = async (params) => {
    const response = await api.post('add_session_db', params);
    return response;
};

export const buscar_produto_detalhes = async (params) => {
    const response = await api.post('buscar_produto_detalhes', params);
    return response;
};

export const buscar_dados_usuario = async (userId) => {
    const response = await api.post('buscar_dados_usuario', { usuario_id: userId });
    return response;
};

export const checkout = async (params) => {
    const response = await api.post('checkout', params);
    return response;
};

export default api;